(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gjl-header-region"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gjl-header-region')) {
    class GjlHeaderRegion extends HTMLElement {
      connectedCallback() {
        if (this.controller || typeof HTMLDialogElement === 'undefined') return;
        this.dialog = this.querySelector('dialog');
        if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
        this.details = this.querySelector('[data-region-details]');
        this.trigger = this.querySelector('summary');
        this.panel = this.querySelector('[data-region-panel]');
        this.closeButton = this.querySelector('[data-region-close]');
        this.form = this.querySelector('form');
        this.submitButton = this.querySelector('[data-region-submit]');
        this.submitLabel = this.querySelector('[data-region-submit-label]');
        this.loadingLabel = this.querySelector('[data-region-loading]');
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.dialog.append(this.panel);
        this.details.open = false;
        this.closeButton.hidden = false;
        this.trigger.setAttribute('aria-controls', this.dialog.id);
        this.trigger.setAttribute('aria-haspopup', 'dialog');
        this.trigger.setAttribute('aria-expanded', 'false');

        this.trigger.addEventListener('click', (event) => {
          event.preventDefault();
          this.openDialog();
        }, options);
        this.closeButton.addEventListener('click', () => this.closeDialog(), options);
        this.dialog.addEventListener('cancel', (event) => {
          event.preventDefault();
          this.closeDialog();
        }, options);
        this.dialog.addEventListener('close', () => {
          if (!this.dialog.open) this.finishClose();
        }, options);
        this.dialog.addEventListener('pointerdown', (event) => {
          this.backdropPressed = this.isBackdrop(event);
        }, options);
        this.dialog.addEventListener('pointercancel', () => { this.backdropPressed = false; }, options);
        this.dialog.addEventListener('click', (event) => {
          if (this.backdropPressed && this.isBackdrop(event)) this.closeDialog();
          this.backdropPressed = false;
        }, options);
        this.form.addEventListener('submit', (event) => {
          if (this.submitting) {
            event.preventDefault();
            return;
          }
          if (event.defaultPrevented) return;
          this.submitting = true;
          this.submitButton.disabled = true;
          this.form.setAttribute('aria-busy', 'true');
          this.submitLabel.hidden = true;
          this.loadingLabel.hidden = false;
        }, options);
        window.addEventListener('pageshow', (event) => {
          if (!event.persisted) return;
          this.closeDialog(false);
          this.resetSubmission();
        }, options);
      }

      disconnectedCallback() {
        this.closeDialog(false);
        this.controller?.abort();
        this.controller = null;
      }

      openDialog() {
        if (this.dialog.open || !this.isConnected) return;
        this.resetSubmission();
        this.lockScroll();
        try {
          this.dialog.showModal();
        } catch (error) {
          this.unlockScroll();
          return;
        }
        this.active = true;
        this.trigger.setAttribute('aria-expanded', 'true');
        this.panel.querySelector('h2').focus({ preventScroll: true });
      }

      closeDialog(restoreFocus = true) {
        if (!this.dialog) return;
        if (this.dialog.open) this.dialog.close();
        this.finishClose(restoreFocus);
      }

      finishClose(restoreFocus = true) {
        const wasActive = this.active;
        this.active = false;
        this.backdropPressed = false;
        this.trigger?.setAttribute('aria-expanded', 'false');
        this.unlockScroll();
        this.resetSubmission();
        if (wasActive && restoreFocus && this.trigger?.isConnected) this.trigger.focus({ preventScroll: true });
      }

      isBackdrop(event) {
        if (event.target !== this.dialog) return false;
        const rect = this.dialog.getBoundingClientRect();
        return event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom;
      }

      lockScroll() {
        if (this.scrollState) return;
        const body = document.body;
        const root = document.documentElement;
        const scrollbar = window.innerWidth - root.clientWidth;
        const paddingRight = parseFloat(getComputedStyle(body).paddingRight) || 0;
        this.scrollState = { x: window.scrollX, y: window.scrollY, styles: [] };
        const set = (element, property, value) => {
          this.scrollState.styles.push([element, property, element.style.getPropertyValue(property), element.style.getPropertyPriority(property)]);
          element.style.setProperty(property, value, 'important');
        };
        set(root, 'overflow', 'hidden');
        set(body, 'position', 'fixed');
        set(body, 'top', `${-this.scrollState.y}px`);
        set(body, 'left', `${-this.scrollState.x}px`);
        set(body, 'width', '100%');
        set(body, 'overflow', 'hidden');
        if (scrollbar > 0) set(body, 'padding-right', `${paddingRight + scrollbar}px`);
      }

      unlockScroll() {
        if (!this.scrollState) return;
        const state = this.scrollState;
        this.scrollState = null;
        const root = document.documentElement;
        const behavior = root.style.getPropertyValue('scroll-behavior');
        const priority = root.style.getPropertyPriority('scroll-behavior');
        root.style.setProperty('scroll-behavior', 'auto', 'important');
        state.styles.reverse().forEach(([element, property, value, savedPriority]) => {
          if (value) element.style.setProperty(property, value, savedPriority);
          else element.style.removeProperty(property);
        });
        window.scrollTo(state.x, state.y);
        if (behavior) root.style.setProperty('scroll-behavior', behavior, priority);
        else root.style.removeProperty('scroll-behavior');
      }

      resetSubmission() {
        this.submitting = false;
        if (!this.submitButton) return;
        this.submitButton.disabled = false;
        this.form.removeAttribute('aria-busy');
        this.submitLabel.hidden = false;
        this.loadingLabel.hidden = true;
      }
    }
    customElements.define('gjl-header-region', GjlHeaderRegion);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gjl-home-product-card"] && !Shopify.designMode) return;
  try {
    (() => {
    // Public Bundler SDK; never changes product prices, cart lines or discounts.
    function buyOnePercent() {
      if (typeof window.bndlr?.getBundles !== 'function') return null;
      const bundles = window.bndlr.getBundles();
      if (!Array.isArray(bundles)) return null;
      const rule = bundles.find(bundle => String(bundle.id) === '864757');
      if (!rule || rule.status !== 'enabled' || rule.product_target_type !== 'all_products'
        || rule.minimum_requirements !== 'volume_discounts' || Number(rule.version) !== 2
        || String(rule.is_quantity_break) !== 'true' || String(rule.use_date_condition) !== 'false'
        || !Array.isArray(rule.limit_for_customer_tags) || rule.limit_for_customer_tags.length
        || !Array.isArray(rule.volume_discounts)) return null;
      const tiers = rule.volume_discounts.filter(tier => Number(tier.min_items) === 1
        && tier.range_type === 'fixed_quantity' && tier.discount_type === 'percentage'
        && (tier.max_items == null || Number(tier.max_items) >= 1)
        && (tier.min_cart_value == null || Number(tier.min_cart_value) === 0));
      if (tiers.length !== 1) return null;
      const percent = Number(tiers[0].discount_value);
      return Number.isFinite(percent) && percent > 0 && percent < 100 ? percent : null;
    }

    function renderBuyOnePrices() {
      let percent = null;
      try { percent = buyOnePercent(); } catch { /* Keep the regular price. */ }
      document.querySelectorAll('.gjl-home [data-gjl-buy-one-card]').forEach(card => {
        const regular = card.querySelector('[data-gjl-regular-price]');
        const sale = card.querySelector('[data-gjl-sale-price]');
        const amount = card.querySelector('[data-gjl-sale-value]');
        const badge = card.querySelector('[data-gjl-sale-badge]');
        if (!regular || !sale || !amount || !badge) return;
        let formatted = '';
        const cents = Number(card.dataset.priceCents);
        if (percent !== null && card.dataset.available === 'true' && Number.isSafeInteger(cents) && cents > 0) {
          // Match Bundler v2: round the discount, then subtract from the price.
          const discounted = cents - Math.round(cents * (percent / 100));
          if (discounted > 0 && discounted < cents) {
            try {
              formatted = new Intl.NumberFormat(document.documentElement.lang || 'en', {
                style: 'currency', currency: card.dataset.currency
              }).format(discounted / 100);
            } catch { /* Unsupported currency: retain the original display. */ }
          }
        }
        amount.textContent = formatted;
        regular.hidden = Boolean(formatted);
        sale.hidden = !formatted;
        badge.hidden = !formatted;
      });
    }

    document.addEventListener('bundler:loaded', renderBuyOnePrices);
    document.addEventListener('shopify:section:load', renderBuyOnePrices);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', renderBuyOnePrices, { once: true });
    } else {
      renderBuyOnePrices();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
